import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import { trademarksPage } from '@/__mocks__/modules/trademarks/data.ts'

export default [
  {
    method: 'GET',
    path: '/trademarks/catalog',
    reply: async () => {
      await wait()
      return [status.ok, trademarksPage]
    }
  },
  {
    method: 'GET',
    path: '/trademarks/catalog?commercialAllyId=2',
    reply: async () => {
      await wait()
      return [status.ok, trademarksPage]
    }
  }
]
